import { type SimpleFetch } from '@spotify-confidence/sdk';

type BlockProvider = () => boolean;

const EVENT_PUBLISH_ENDPOINT = '/events:publish';

const WRITE_ENDPOINTS = [
  '/flags:apply',
  EVENT_PUBLISH_ENDPOINT,
  '/telemetry:upload',
];

const blockedResponse = (request: Request): Response => {
  if (request.url.endsWith(EVENT_PUBLISH_ENDPOINT)) {
    return new Response(JSON.stringify({ errors: [] }), {
      status: 200,
      headers: { 'Content-Type': 'application/json' },
    });
  }

  return new Response(null, { status: 200 });
};

const createBlockingFetchImplementation = (
  endpoints: readonly string[],
  blockProvider: BlockProvider,
  fetchImplementation: SimpleFetch,
): SimpleFetch => {
  const isBlockedRequest = (request: Request): boolean =>
    endpoints.some(endpoint => request.url.endsWith(endpoint));

  return async request => {
    if (blockProvider() && isBlockedRequest(request)) {
      return blockedResponse(request);
    }

    return fetchImplementation(request);
  };
};

export const createReadOnlyFetchImplementation = (
  readOnlyProvider: BlockProvider,
  fetchImplementation: SimpleFetch = fetch,
): SimpleFetch =>
  createBlockingFetchImplementation(
    WRITE_ENDPOINTS,
    readOnlyProvider,
    fetchImplementation,
  );

export const createEventBlockingFetchImplementation = (
  blockProvider: BlockProvider,
  fetchImplementation: SimpleFetch = fetch,
): SimpleFetch =>
  createBlockingFetchImplementation(
    [EVENT_PUBLISH_ENDPOINT],
    blockProvider,
    fetchImplementation,
  );
